<template>
  <div class="end-wrapper" :class="{ stamp2: mode === 'stamp2', incein: isIncein }" @click="goBack">
    <template v-if="isIncein">
      <div class="flex flex-col w-full mt-32 px-32 text-center">
        <h1 class="screen-info">{{ $t('stamp.end_goodjob') }}</h1>
        <h2 class="screen-name mt-6">
          <p v-html="$t('stamp.end_line')"></p>
        </h2>
      </div>
      <div class="flex flex-1 justify-center overflow-hidden w-full pt-20 px-44">
        <div class="img w-full bg-contain bg-no-repeat">
          <img
            class="mx-auto xs:w-1/4 sm:w-1/4 sm:mt-64 lg:my-64 lg:pt-32"
            src="../../assets/stamp/incein-qr.jpg"
            alt="QR"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import incein from '@/mixins/incein';

export default {
  mixins: [incein],
  name: 'StampEnd',
  mounted() {
    this.timer = setTimeout(() => {
      this.goBack();
    }, 180000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    goBack() {
      this.$events.goto('Welcome');
    },
  },
  computed: {
    ...mapState('app', ['mode']),
  },
};
</script>

<style lang="scss" scoped>
.end-wrapper {
  @apply flex-col w-full h-full flex justify-start items-center bg-no-repeat bg-contain bg-black;
  background-image: url('https://cdn.shopify.com/s/files/1/0076/0882/7975/files/ipad_image_0430_last_image.png?v=1619764345');
  &.stamp2 {
    background-image: url('https://cdn.shopify.com/s/files/1/0076/0882/7975/files/2021-06-15_21.28.08.png?v=1623760107');
  }
  &.incein {
    .screen-info {
      font-size: 28px;
      line-height: 1.66;
      @screen lg {
        font-size: 40px;
      }
    }
    .screen-name {
      font-size: 20px;
      font-weight: 500;
      line-height: 35px;
    }
    .px-44 {
      padding-left: 11rem;
      padding-right: 11rem;
    }
    .img {
      @apply bg-center;
      background-image: url('../../assets/stamp/group.png');
    }
    background: #fafaf9 none;
    color: #262326;
  }
}
</style>
